import type {
  OrganizationContactUpdateRequest,
  OrganizationCreateRequest,
  OrganizationCreateResponse,
  OrganizationGeneralUpdateRequest,
  OrganizationGetAllInsuranceParams,
  OrganizationGetAllInsurancesResponse,
  OrganizationGetAllResponse,
  OrganizationGetResponse,
  OrganizationSearch,
  OrganizationUpdateResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class OrganizationApi {
  public async getOrganization(id: string): Promise<OrganizationGetResponse> {
    const result = await trpcClient.organization.getById.query({ id });

    return result;
  }

  public async createOrganization(
    organization: OrganizationCreateRequest,
  ): Promise<OrganizationCreateResponse> {
    return await trpcClient.organization.create.mutate(organization);
  }

  public async updateOrganizationContact(
    params: OrganizationContactUpdateRequest,
  ): Promise<OrganizationGetResponse> {
    return await trpcClient.organization.updateContact.mutate({
      ...params,
    });
  }

  public async updateOrganizationGeneral(
    params: OrganizationGeneralUpdateRequest,
  ): Promise<OrganizationUpdateResponse> {
    return await trpcClient.organization.updateGeneral.mutate({
      ...params,
    });
  }

  public async getInsuranceOrganizations(
    params?: OrganizationGetAllInsuranceParams,
  ): Promise<OrganizationGetAllInsurancesResponse> {
    return await trpcClient.organization.getAllInsurance.query({ ...params });
  }

  public async getAll(
    params: OrganizationSearch,
  ): Promise<OrganizationGetAllResponse> {
    return await trpcClient.organization.getAll.query({
      ...params,
    });
  }
}
